import request from '@/api/request'

export interface AgreementAdminBody {
  id: number
  content: string
}

export function fetchAgreementAdmin(id: number) {
  return request.get<AgreementAdminBody>(`/api/admin/system/agreements/${id}`)
}

export function saveAgreementAdmin(id: number, content: string) {
  return request.put<{ status?: number; msg?: string }>(`/api/admin/system/agreements/${id}`, { content })
}
